export default __webpack_public_path__ + "static/media/btn_google_dark_normal.9fe90a17.svg";